module.exports = __webpack_public_path__ + "img/featuredartist (5).369e451f.jpg";